import {SectionView} from '../../ui_canvas_engine/SectionView'
import {InGameAchievement} from './UIGameAchievementController'
import {PIXI} from '@colonist/pixi'
import {TextView} from '../../ui_canvas_engine/TextView'
import {GameFont} from '../../GameFont'
import {GameColor} from '../../GameColor'
import {clientI18n} from '../../ClientI18n'
import {UIGamePlayerAvatarView} from '../ui_game_players/UIGamePlayerAvatarView'
import {UIGameManager} from '../UIGameManager'
import {TextTruncatedView} from '../../ui_canvas_engine/TextTruncatedView'
import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {TranslationObject} from '@colonist/i18n'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {PlayerColor} from '@colonist/game-states'

export class UIGameAchievementDescriptionSectionView extends SectionView {
    private readonly achievementOptions: InGameAchievement
    private readonly uiGameManager: UIGameManager
    private readonly margin: number
    private readonly avatarSize: number

    constructor(x: number, y: number, width: number, height: number, parent: PIXI.Container, uiGameManager: UIGameManager, options: InGameAchievement, margin: number, avatarSize: number) {
        super(x, y, width, height, parent)
        this.achievementOptions = options
        this.uiGameManager = uiGameManager
        this.margin = margin
        this.avatarSize = avatarSize
    }

    createVPChangeView(usernameView: TextView, forAchiever: boolean = true, alignToRight: boolean = false): TextView {
        const y = usernameView.y + usernameView.height + this.margin * 0.3
        const vpChangeY = alignToRight ? usernameView.y : y
        const height = alignToRight ? usernameView.height : this.margin
        const color = forAchiever ? GameColor.Color.GreenLink : GameColor.Color.Gray2
        const text = this.getVPChangeText(forAchiever)

        const vpChangeTextView = new TextView(text, 0, vpChangeY, this.width, height, this, GameFont.Size.Normal, GameColor.getColor(color))

        if(alignToRight) {
            vpChangeTextView.x = this.width - vpChangeTextView.width - this.margin
        } else {
            vpChangeTextView.x = usernameView.x + (usernameView.width / 2) - (vpChangeTextView.width / 2)
        }

        return vpChangeTextView
    }

    private getVPChangeText(increase: boolean = true): TranslationObject {
        const operationSign = increase ? '+' : '-'
        const vpChangeOperationText = `${operationSign} ${this.achievementOptions.victoryPointChange}`
        const vpInitials = this.getLocalVictoryPointInitials()
        const vpChangeText = `${vpChangeOperationText} ${vpInitials}`

        return {key: 'strings:colonistCommon.utils.#buffer', options: {value: vpChangeText}}
    }

    // eslint-disable-next-line class-methods-use-this
    private getLocalVictoryPointInitials(): string {
        const victoryPointText = clientI18n.t('strings:game.playerInformation.victoryPoint.title')
        const vpInitials = victoryPointText.split(' ').map((word) => word[0]).join('')
        return vpInitials
    }

    createAvatar(x: number, player: PlayerColor): UIGamePlayerAvatarView {
        const playerController = this.uiGameManager.gameController.getPlayerState(player)
        const y = this.margin

        return new UIGamePlayerAvatarView(x, y, this.avatarSize, this, playerController)
    }

    createPlayerName(rightEnd: number, avatar: UIGamePlayerAvatarView, fontSize: GameFont.Size, player: PlayerColor): TextTruncatedView {
        const name = this.uiGameManager.gameController.getPlayerNameWithColor(player)
        const x = avatar.x + avatar.width + this.margin
        const width = rightEnd - x - this.margin

        const playerNameView = new TextTruncatedView(name, x, avatar.y, width, avatar.height, this, fontSize, GameColor.getColor(GameColor.Color.White))
        playerNameView.makeSemiBold()
        return playerNameView
    }

    createDescriptionText(x: number, y: number, width: number, height: number): TextView {
        const descriptionView = new TextView(this.achievementOptions.bottomDescription, x, y, width, height, this, GameFont.Size.Normal, GameColor.getColor(GameColor.Color.White))
        descriptionView.changeStyle({align: 'left'})
        descriptionView.repositionY(false)

        return descriptionView
    }

    createGreenArrowIcon(bearingAvatar: UIGamePlayerAvatarView): SpriteView {
        const arrowTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_trade_arrow_green).clone()
        arrowTexture.rotate = 4
        const height = this.width * 0.08
        const width = height * (arrowTexture.width / arrowTexture.height)
        const x = (this.width - width) / 2
        const y = bearingAvatar.y + (bearingAvatar.height - height) / 2

        return new SpriteView(x, y, width, height, this, arrowTexture)
    }

    centralizePlayerAvatarAndName(avatar: UIGamePlayerAvatarView, playerName: TextTruncatedView, containerBeginning: number, containerEnd: number) {
        const avatarNameWidth = avatar.width + playerName.width + this.margin
        const containerMiddlePoint = (containerBeginning + containerEnd) / 2
        const avatarX = containerMiddlePoint - avatarNameWidth / 2
        const isAvatarWithinContainer = containerBeginning + this.margin < avatarX
        const avatarMargin = isAvatarWithinContainer ? avatarX : containerBeginning + this.margin

        playerName.x = avatarMargin + avatar.width + this.margin
        avatar.x = (containerBeginning + playerName.x - avatar.width) / 2
        playerName.repositionY(false)
    }
}
